import React, { ChangeEvent, useEffect, useState } from "react";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";

interface PortionVolumeInputProps {
    id: string;
    name: string;
    placeholder: string;
    disabled?: boolean;
    maxLength?: number;
    initialValue?: number | string | null;
}

const PortionVolumeInput: React.FC<PortionVolumeInputProps> = ({
    id,
    name,
    placeholder,
    disabled,
    maxLength = 7,
    initialValue,
}) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [, meta] = useField(name);
    const [value, setValue] = useState("");

    useEffect(() => {
        if (initialValue !== undefined && initialValue !== null && initialValue !== "") {
            let numericValue: number;

            if (typeof initialValue === "string") {
                numericValue = parseFloat(initialValue);
            } else {
                numericValue = initialValue;
            }

            if (!isNaN(numericValue)) {
                setValue(numericValue.toFixed(1));
            } else {
                setValue("");
            }
        } else {
            setValue("");
        }
    }, [initialValue]);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const inputValue = e.target.value.trim();
        const regex = /^(\d+)?(\.\d{0,1})?$|^$/;

        if (regex.test(inputValue)) {
            setValue(inputValue);
        }
    };

    const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.trim();

        if (inputValue === "" || inputValue === ".") {
            setValue("");
            setFieldTouched(name, true, true);
            setFieldValue(name, null);
        } else {
            const numericValue = parseFloat(inputValue);

            if (!isNaN(numericValue)) {
                if (numericValue >= 1.0 && numericValue <= 10000.0) {
                    const formattedValue = numericValue.toFixed(1);
                    setValue(formattedValue);
                    setFieldValue(name, parseFloat(formattedValue));
                } else {
                    setFieldTouched(name, true, true);
                    setFieldValue(name, numericValue, false);
                }
            } else {
                setValue("");
                setFieldValue(name, null);
                setFieldTouched(name, true, true);
            }
        }
    };

    return (
        <div className="position-relative">
            <Field
                name={name}
                type="text"
                id={id}
                placeholder={placeholder}
                value={value}
                className={`form-control ${meta.touched && meta.error ? "is-invalid" : ""}`}
                onBlur={handleBlur}
                onChange={handleChange}
                disabled={disabled}
                maxLength={maxLength}
            />
            <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
        </div>
    );
};

export default PortionVolumeInput;
